var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.downloadKey)?_c('pdf-viewer',{class:_vm.viewerclass,attrs:{"url":_vm.urlWithKey}}):_c('div',{staticClass:"spinner-border text-dark",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }